export const TAB_NAME_TO_VALUE = {
  Overview: 0,
  Engagement: 1,
  Sessions: 2,
  Surveys: 3,
  Pairing: 4,
  Goals: 5,
  Demographics: 6,
  Schools: 7,
  Trends: 8,
};

export const BASE_TABS = [
  'Overview',
  'Engagement',
  'Sessions',
  'Surveys',
  'Pairing',
  'Goals',
  'Demographics',
];

